import OutboundOrderLoadSimplifiedRequests from '../../server/outboundOrderLoadSimplified';
import { addLoading, removeLoading } from './loading';

export const getSimplifiedLoadMonitorDocuments = (
  startDate,
  endDate
) => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await OutboundOrderLoadSimplifiedRequests.getMonitorDocuments(
      startDate,
      endDate
    );
  } finally {
    dispatch(removeLoading());
  }
};

export const getSimplifiedLoadMonitorProducts = (
  outboundOrderLoadSimplifiedId
) => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await OutboundOrderLoadSimplifiedRequests.getMonitorProducts(
      outboundOrderLoadSimplifiedId
    );
  } finally {
    dispatch(removeLoading());
  }
};

export const cancelSimplifiedLoadDocument = (
  outboundOrderLoadSimplifiedId,
) => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await OutboundOrderLoadSimplifiedRequests.cancelDocument(
      outboundOrderLoadSimplifiedId,
    );
  } finally {
    dispatch(removeLoading());
  }
};

export const cancelSimplifiedLoadProduct = (
  outboundOrderLoadSimplifiedProductId,
) => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await OutboundOrderLoadSimplifiedRequests.cancelProduct(
      outboundOrderLoadSimplifiedProductId,
    );
  } finally {
    dispatch(removeLoading());
  }
};

export const generateOutboundOrderFromSimplifiedLoad = (
  outboundOrderLoadSimplifiedIds
) => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await OutboundOrderLoadSimplifiedRequests.generateOutboundOrderFromLoad(
      outboundOrderLoadSimplifiedIds
    );
  } finally {
    dispatch(removeLoading());
  }
};
